import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CloudSunIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep water-glow tech-grid relative isolate overflow-hidden" data-id="element-103" data-mp="sai16upzuf2k">
      <div className="metal-bar h-2 w-full" aria-hidden="true" data-id="element-104" data-mp="nczr3108ptsz" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="3d1ikzavvpeny">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md border border-silver/40 bg-white/5 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-silver" data-id="element-106" data-mp="3cz5ug9c21vza">
          <CloudSunIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="399bahlnnj9ux" /> Meteorology &amp; Atmospheric Science Teacher Ready
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-white sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="3ebirwqr93i4n">
          Master your year of weather &amp; atmospheric processes
          <br data-id="element-109" data-mp="2vj7u3bbgeade" />
          <span className="text-silver" data-id="element-110" data-mp="2vgtwovtawm2o">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2hjyo14gyown5">
          <img src={productImage} alt="Meteorology & Atmospheric Science Teacher Ready: nine volumes and five exclusive bonuses covering atmospheric fundamentals, thermodynamics, clouds, weather systems, severe weather, observation, forecasting and climate" className="mx-auto w-full rounded-xl drop-shadow-[0_24px_44px_rgba(2,12,22,.7)]" data-id="element-112" data-mp="nat65811aej4" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="161ja702cc7dk">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="162c8rdr5bqkm">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-silverBright" data-id="element-115" data-mp="x1ec5gj1elc2">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-silverEdge bg-navy/70 px-3 py-2" data-id="element-116" data-mp="3lquf1phvu95l">
              <Icon className="h-3.5 w-3.5 text-silver" aria-hidden="true" data-id="element-117" data-mp="1xam5iqqvrqyx" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-silverDark" data-id="element-118" data-mp="218jvhvsh6h3d">
          Created by meteorology specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}